import InternalButton from './button';
import Dropdown from './group';
var Button = InternalButton;
Button.Dropdown = Dropdown;
export default Button;